
import { ActionIcon, Badge, Divider, Grid, Input, Paper, Title } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import React from 'react';
import { FaMinusSquare, FaPaperPlane } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { GET_ENTITY_DATA, SAVE_ENTITY_KEYWORDS } from '../../services/entities';

export default function UsersPage(){
    const [data, setData] = React.useState(null);
    const [keywordInput, setKeywordInput] = React.useState("");
    const [loadingSaveKeyword, setLoadingSaveKeyword] = React.useState(false);

    const { id } = useParams();

    const saveKeyword = e => {
        e.preventDefault();

        if(keywordInput.replace(/ /g, "").length >= 3){
            const ks = [ ...(data?.keywords || []), ...keywordInput.split(",") ];
            setLoadingSaveKeyword(true);
            setKeywordInput("")
            SAVE_ENTITY_KEYWORDS(id, ks)
            .then(res => {
                setLoadingSaveKeyword(false);
                setData(c => ({...c, keywords: ks}))
            })
            .catch(err => {
                setLoadingSaveKeyword(false);
                showNotification({title: "Ops.", message: err.message, color: 'red'})
            })
        }else{
            showNotification({title: "Ops", message: "Informe pelo menos 3 caracteres"})
        }
    }
    
    const removeKeyword = keyword => {
        const oldValue = (data?.keywords || []);
        const ks = oldValue.filter(k => k !== keyword);
        setData(c => ({...c, keywords: ks}))

        SAVE_ENTITY_KEYWORDS(id, ks)
        .then(res => {})
        .catch(err => {
            setData(c => ({...c, keywords: oldValue}))
            showNotification({title: "Ops.", message: err.message, color: 'red'})
        })
    }

    React.useEffect(() => {
        GET_ENTITY_DATA(id)
        .then((entity) => {
            setData(entity)
        })
        .catch(err => {
            showNotification({title: "Ops.", message: err.message, color: 'red'})
        })
    }, [])

    return <>
        <Grid>
            <Grid.Col md={8} sm={12}>
                <Paper p="md" mb="md">
                    <>
                        <Badge mb="md" color="blue">Entidade</Badge>
                        <Title order={2}>{data?.name}</Title>
                    </>
                    
                    <Divider mt="md" mb="md" />

                    <form onSubmit={saveKeyword}>
                        <Input.Wrapper
                            id="keyword-input"
                            label="Palavras chaves"
                            description="Insira uma palavra-chave para monitorar atividades"
                            >
                            <Input
                                id="keyword-input"
                                placeholder="Palavra-chave"
                                value={keywordInput}
                                onChange={e => setKeywordInput(e.target.value)}
                                rightSection={
                                    <ActionIcon loading={loadingSaveKeyword} type='submit' variant='light'>
                                        <FaPaperPlane />
                                    </ActionIcon>
                                }
                            />
                        </Input.Wrapper>
                    </form>

                    {(data?.keywords || []).map(c => <Badge
                        color="yellow"
                        mr="sm"
                        mt="sm"
                        size='lg'
                        rightSection={<ActionIcon onClick={() => removeKeyword(c)} variant="light"><FaMinusSquare/></ActionIcon>}
                    >{c}</Badge>)}

                    <Divider mt="lg" mb="lg" />

                </Paper>
            </Grid.Col>
        </Grid>
    </>
}
